









import Vue from 'vue'
// @ts-ignore
import Pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css';


export default Vue.extend({

  props: {
    url: { type: String },
  },

  data() {
    return {
      pdfh5: null,

    }
  },


  mounted() {


    this.pdfPage();

  },
  methods: {

    // 计算pdf文档的页数
    pdfPage() {
      this.pdfh5 = new Pdfh5("#pdfview", {
        pdfurl: this.url, // pdf 地址，请求的地址需要为线上的地址，测试的本地的地址是不可以的
        lazy: false, // 是否懒加载
        // withCredentials: true,
        renderType: "canvas",
        cMapUrl: "https://unpkg.com/pdfjs-dist@3.8.162/cmaps/",
        maxZoom: 2.5, //手势缩放最大倍数 默认3
        scrollEnable: true, //是否允许pdf滚动
        zoomEnable: true, //是否允许pdf手势缩放
      });
      //监听完成事件
      // @ts-ignore
      this.pdfh5.on("complete", function (status, msg, time) {
        console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒");
      });
    },

  }
})
